module.exports = __webpack_public_path__ + "static/img/39-1.d86ab1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/39-1.jpg
// module id = +o6Y
// module chunks = 0